import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MembershipPointstoCurrencyRateContainerModel } from '../../../../../../models/aggregates/crm/membership-points-currency';
import { Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class MembershipPointstoCurrencyRateService extends BaseApiPublicLoginTemplateService<MembershipPointstoCurrencyRateContainerModel, MembershipPointstoCurrencyRateContainerModel, MembershipPointstoCurrencyRateContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-to-currency-rate';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-to-currency-rate';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-to-currency-rate';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'membership-points-to-currency-rate/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.httpClient = http;
  }
}

